import $ from 'jquery';

let UNIQUE_ID_NUMBER = 0;

function setId ($element, prefix = 'setIdPrefix') {
    let id = $element.attr('id');
    if (!id) {
        id = `${prefix}-${UNIQUE_ID_NUMBER++}`;
        $element.attr('id', id);
    }
    return id;
}

function onClickEnterOrSpace ($element, callback) {
    $element.on('click', callback);
    $element.on('keydown', function (e) {
        if (e.key === ' ') e.preventDefault(); // prevent scrolling when pressing space
        if (e.key === 'Enter' || e.key === ' ') {
            callback.call(this, arguments);
        }
    });
}

function updateContentSize ($container, $content) {
    if (!$container.hasClass('open')) {
        $content.css('height', $content[0].scrollHeight);
        setTimeout(() => {
            $content.css('height', 0);
        });
    } else {
        setTimeout(() => {
            $content.css('height', $content[0].scrollHeight);
        });
    }
}

function focusHeaderByIndex ($header, headerIndex) {
    const headers = $header
        .closest('.accordion__group')
        .find('.accordion__header');
    const index   = (headers.length + headerIndex) % headers.length;
    headers.get(index).focus();
}

function initAccordion (accordionIndex) {
    const $container = $(this);
    const $header    = $container.find('.accordion__header');
    const $content   = $container.find('.accordion__content');

    const headerId  = setId($header, 'accordion-header');
    const contentId = setId($content, 'accordion-content');

    $content.attr('aria-labelledby', headerId);
    $header.attr('aria-controls', contentId);

    $container.on('toggle', function () {
        if ($container.hasClass('open')) {
            $container.trigger('close');
        } else {
            $container.trigger('open');
        }
    });

    $container.on('close', function () {
        $header.attr('aria-expanded', 'false');
        $container.removeClass('open');
        updateContentSize($container, $content);
    });

    $container.on('open', function () {
        $content.css('display', 'block');
        $header.attr('aria-expanded', 'true');
        $container.addClass('open');
        updateContentSize($container, $content);
    });

    onClickEnterOrSpace($header, function () {
        $container.trigger('toggle');
    });

    $header.on('keydown', function (e) {
        switch (e.key) {
            default:
                break;
            case 'Home':
                focusHeaderByIndex($header, 0);
                e.preventDefault();
                break;
            case 'End':
                focusHeaderByIndex($header, -1);
                e.preventDefault();
                break;
            case 'ArrowUp':
                focusHeaderByIndex($header, accordionIndex - 1);
                e.preventDefault();
                break;
            case 'ArrowDown':
                focusHeaderByIndex($header, accordionIndex + 1);
                e.preventDefault();
                break;
        }
    });

    $content.on('transitionend', () => {
        if ($container.hasClass('open')) {
            $content.css('height', 'auto');
        } else {
            $content.css('display', 'none');
        }
    });

    $container.trigger('close');
}

function initToggleAllBtn ($containers) {
    const areAllOpen = () => $containers.filter('.open').length === $containers.length;

    function toggleAll () {
        const eventToTrigger = areAllOpen() ? 'close' : 'open';
        $containers.each(function () {
            $(this).trigger(eventToTrigger);
        });
    };

    function updateToggleAll (toggleAll) {
        return function () {
            setTimeout(function () {
                const $toggleAll = $(toggleAll);
                const text       = areAllOpen() ? $toggleAll.data('accordion-toggle-text-closed') : $toggleAll.data('accordion-toggle-text-open');
                $toggleAll.text(text);
            });
        };
    }

    return function () {
        this.tabIndex = 0;
        this.role     = 'button';
        onClickEnterOrSpace($(this), toggleAll);
        $containers.on('close open', updateToggleAll(this));
    };
}

$('.accordion__group').each(function () {
    const $group      = $(this);
    const $containers = $group.children('.accordion__container');
    $group
        .find('[data-accordion-toggle-all]')
        .each(initToggleAllBtn($containers));
    $containers.each(initAccordion);
});

// JIRA: RKP-133
